import { useEffect, useState, useContext } from 'react';
import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';
import {
    ENHANCED_BUYER_INCENTIVES,
    ENHANCED_BUYER_INCENTIVES_DESKTOP,
} from '../../constants/abTestsConstants';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

export const useEnhancedBuyerIncentivesClientVariant = (): boolean | null => {
    const { isMobile } = useContext(ServerVarsContext);
    const [isEnhancedBuyerIncentivesClient, setIsEnhancedBuyerIncentivesClient] = useState<
        boolean | null
    >(null);

    useEffect(() => {
        const isBuyerIncentivesVariantMobile =
            getAbTestV2(ENHANCED_BUYER_INCENTIVES)?.variant === 'variant' && isMobile;
        const isBuyerIncentivesVariant1Resp =
            getAbTestV2(ENHANCED_BUYER_INCENTIVES_DESKTOP)?.variant === 'variant-1' && !isMobile;
        const isBuyerIncentivesVariant2Resp =
            getAbTestV2(ENHANCED_BUYER_INCENTIVES_DESKTOP)?.variant === 'variant-2' && !isMobile;

        setIsEnhancedBuyerIncentivesClient(
            isBuyerIncentivesVariantMobile ||
                isBuyerIncentivesVariant1Resp ||
                isBuyerIncentivesVariant2Resp
        );
    }, [isMobile]);

    return isEnhancedBuyerIncentivesClient;
};
